import { ProductOfferCard as ProductOfferCardType } from '@varo/graphql-schema-types';
import MoveMoneyHeaderCard from 'features/moveMoney/components/MoveMoneyHeaderCard/MoveMoneyHeaderCard';
import { VXLReactNode } from 'shared/renderer/types';

export const buildMoveMoneyHeaderReactNode = (
  headerCard: ProductOfferCardType,
  onHeaderPress: () => void,
): VXLReactNode => ({
  id: headerCard.id,
  render: () => (
    <MoveMoneyHeaderCard
      headerCard={headerCard}
      onHeaderPress={onHeaderPress}
    />
  ),
});
